import { forwardRef, FC } from 'react'
import { Button, StyleProps, useBreakpointValue } from '@chakra-ui/react'

const CarplannerButton: FC<ButtonsGlobal.Button & StyleProps> = forwardRef(({ title, width, action, disabled, onClick, ...others }, ref) => {
  const buttonSize = useBreakpointValue(['md', 'lg'])

  return <Button
    variant="outline"
    bg="primaryGreen.600"
    color="baseWhite"
    fontFamily="Montserrat-SemiBold"
    borderRadius={4}
    display="block"
    overflow="hidden"
    title={title}
    disabled={disabled}
    width={width || '100%'}
    size={buttonSize}
    borderColor="primaryGreen.300"
    px={{ base: '0.75rem', md: '1rem' }}
    _active={{
      bg: 'primaryGreen.800',
      borderColor: 'primaryGreen.800',
      color: 'baseWhite',
    }}
    _hover={{
      bg: disabled ? '' : 'primaryGreen.300',
      borderColor: disabled ? '' : 'primaryGreen.900',
      color: disabled ? '' : 'baseWhite',
    }}
    _disabled={{
      bg: 'baseNeutral.200',
      color: 'baseNeutral.400',
      cursor: 'default'
    }}
    onClick={onClick}
    {...others}
  >
    {action}
  </Button>
})

export default CarplannerButton
